import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Card, CardTitle } from 'reactstrap';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import {
	FormGroup,
	Label,	
} from 'reactstrap';
import DatePicker from "react-datepicker";
import moment from 'moment';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { 
    stdBDFivePutts,
    stdBDFivePoints,
    stdBDTenPutts,
    stdBDTenPoints,
    stdBDFifteenPutts,
    stdBDFifteenPoints,
    stdBDHundredPoints,
    fetchPuttPerformanceChart,
    studentPuttPerformance,
    fetchPuttPerformance,
    deletePuttPerformance,
    fetchPlayerIntervention
 } from 'Actions';
 import ConfirmationDialog from "Routes/common/ConfirmationDialog";
 // rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import Point5System from '../../../../golf/putt/broadiedrill5/component/pointsystem';
import Putt5System from '../../../../golf/putt/broadiedrill5/component/puttsystem';
import Point10System from '../../../../golf/putt/broadiedrill10/component/pointsystem';
import Putt10System from '../../../../golf/putt/broadiedrill10/component/puttsystem';
import Point15System from '../../../../golf/putt/broadiedrill15/component/pointsystem';
import Putt15System from '../../../../golf/putt/broadiedrill15/component/puttsystem';
import Point100System from '../../../../golf/putt/broadiedrill100/component/pointsystem';

import ViewChart from '../../../../golf/putt/puttchart/component/rightchart';
import StrokesChart from '../../../../golf/putt/puttchart/component/strokeschart';
import PuttOneChart from '../../../../golf/putt/puttchart/component/puttone';
import PuttTwoChart from '../../../../golf/putt/puttchart/component/putttwo';
import PuttThreeChart from '../../../../golf/putt/puttchart/component/puttthree';
import StrokesLine from '../../../../golf/putt/puttchart/component/strokesline';

import AddItem from '../../../../golf/putt/puttperformance/component/addform';
import EditItem from '../../../../golf/putt/puttperformance/component/editform';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';


class GolfRangeTest extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            student:this.props.data.student, 
            startdate:'',
            enddate:'',
            loader:false,
            maindiv:true,
            putt5div:false,
            putt10div:false,
            putt15div:false,
            putt100div:false,
            puttperdiv:false,
            puttstartdate:'',
            puttselectend:'',
            viewdiv2:true,
            adddiv:false,
            viewdiv:true,
            listdiv:false,
            editdiv:false,
            sepmore:1,
            totavgpoints:0,
            formValues: [{ puttlength:"", noputt:"", putttype:"", right : "", left : "", short : "", long : "", avgputt:"", strokes:"", disright:"", disleft:"", disshort:"", dislong:""}],
            puttformValues: [{ puttdate:"", noputt:""}],
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.onPuttBackSection = this.onPuttBackSection.bind(this);
        this.onEditBack = this.onEditBack.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.viewList = this.viewList.bind(this);
    }

    rangeSelection(id){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        
       if(id==1){
            this.props.stdBDFivePutts(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                
                    {resdata.map((teamval, idx) => (   
                        
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        puttformValues:troptobj,
                        putsepmore:resdata.length,
                        putlinedata:[...alldata],
                        putlinemax:maxNumber,
                        totavgputts:totavg
                    });
                }else{
                    this.setState({
                        puttformValues: [{ puttdate:"", noputt:""}],
                        putsepmore:1,
                        putlinedata:[],
                        putlinemax:20,  
                    });  
                }

            });
            
            this.props.stdBDFivePoints(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                
                    {resdata.map((teamval, idx) => (   
                        
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));                
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        formValues:troptobj,
                        sepmore:resdata.length,
                        linedata:[...alldata],
                        linemax:maxNumber,
                        totavgpoints:totavg
                    });
                }else{
                    this.setState({
                        formValues: [{ puttdate:"", noputt:""}],
                        sepmore:1,
                        linedata:[],
                        linemax:20,  
                    });  
                }

                this.setState({ 
                    maindiv:false,
                    putt5div:true,
                });

            });
                
        }else if(id==2){
            this.props.stdBDTenPutts(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                   
                    {resdata.map((teamval, idx) => (   
                         
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        puttformValues:troptobj,
                        putsepmore:resdata.length,
                        putlinedata:[...alldata],
                        putlinemax:maxNumber,
                        totavgputts:totavg
                    });
                }else{
                    this.setState({
                        puttformValues: [{ puttdate:"", noputt:""}],
                        putsepmore:1,
                        putlinedata:[],
                        putlinemax:20,  
                    });  
                }
    
            });
            
            this.props.stdBDTenPoints(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                   
                    {resdata.map((teamval, idx) => (   
                         
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        formValues:troptobj,
                        sepmore:resdata.length,
                        linedata:[...alldata],
                        linemax:maxNumber,
                        totavgpoints:totavg
                    });
                }else{
                    this.setState({
                        formValues: [{ puttdate:"", noputt:""}],
                        sepmore:1,
                        linedata:[],
                        linemax:20,  
                    });  
                }
    
                this.setState({ 
                    maindiv:false,
                    putt10div:true,
                });
    
            });
        }else if(id==3){
            this.props.stdBDFifteenPutts(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                   
                    {resdata.map((teamval, idx) => (   
                         
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        puttformValues:troptobj,
                        putsepmore:resdata.length,
                        putlinedata:[...alldata],
                        putlinemax:maxNumber,
                        totavgputts:totavg
                    });
                }else{
                    this.setState({
                        puttformValues: [{ puttdate:"", noputt:""}],
                        putsepmore:1,
                        putlinedata:[],
                        putlinemax:20,  
                    });  
                }
    
            });
            
            this.props.stdBDFifteenPoints(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                   
                    {resdata.map((teamval, idx) => (   
                         
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        formValues:troptobj,
                        sepmore:resdata.length,
                        linedata:[...alldata],
                        linemax:maxNumber,
                        totavgpoints:totavg
                    });
                }else{
                    this.setState({
                        formValues: [{ puttdate:"", noputt:""}],
                        sepmore:1,
                        linedata:[],
                        linemax:20,  
                    });  
                }
    
                this.setState({ 
                    maindiv:false,
                    putt15div:true,
                });
    
            });    
        }else if(id==4){

            this.props.stdBDHundredPoints(student, stdate, eddate).then((data) => {   
                var resdata=data.data;
                var troptobj=[]; 
                var alldata=[]; 
                var highval=[];
                var st=0;
                if(resdata.length!=0){
                   
                    {resdata.map((teamval, idx) => (   
                         
                        troptobj.push({
                            puttdate:new Date(teamval.gpb_date),
                            noputt:teamval.gpb_points,
                        }),
                        alldata.push({
                            x:idx+1,
                            y:teamval.gpb_points,
                        }),
                        highval[idx]=teamval.gpb_points,
                        st=st+teamval.gpb_points
                        
                    ))}
                    var totavg=parseFloat((st/resdata.length).toFixed(2));
                    const maxNumber = Math.max(...highval)+10;
                    this.setState({
                        formValues:troptobj,
                        sepmore:resdata.length,
                        linedata:[...alldata],
                        linemax:maxNumber,
                        totavgpoints:totavg
                    });
                }else{
                    this.setState({
                        formValues: [{ puttdate:"", noputt:""}],
                        sepmore:1,
                        linedata:[],
                        linemax:20,  
                    });  
                }
    
                this.setState({ 
                    maindiv:false,
                    putt100div:true,
                });
    
            });
            
        }else if(id==5){    
            var distance='';
            var puttype='';
            this.props.fetchPuttPerformanceChart(student, stdate, eddate, distance, puttype).then((data) => {   
                    
                this.setState({ 
                    maindiv:false,
                    puttperdiv:true,
                });
    
            });
        }    
    }

    onBackSection() {
        var student=this.state.student;
        var stdate='';
        var eddate='';
        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => { 
            this.setState({ 
                maindiv:true,
                putt5div:false,
                putt10div:false,
                putt15div:false,
                putt100div:false,
                puttperdiv:false,
            });
        });
	}

    puttselectstart = (date) => {  
        this.setState({ puttstartdate:date });           
    }

    puttselectend = (date) => {  
        this.setState({ puttenddate:date });           
    }

    puttPerformanceSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.puttstartdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.puttenddate)).format('yyyy-MM-DD');       
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });
        
       
        this.props.fetchPuttPerformanceChart(student, stdate, eddate).then((data) => {   
            var resdata=data.data;            
            this.setState({ 
                loader:false,
                viewdiv2:true,  
            });

        });
    } 

    addEntry(){
        this.setState({ 
            adddiv:true,
            viewdiv2:false,
            
       });
    }

    viewList(){
        var stdid=this.state.student;
        var start='';
        var end='';
        this.props.studentPuttPerformance(stdid, start, end).then((data) => {   
            
            this.setState({ 
                viewdiv2:false,
                listdiv:true
            });

        });
        
    }

    onEditBack() {
		this.setState({ 
            adddiv:false,
            editdiv:false,
            listdiv:true,
       });
	}

    editAssessment(assmval){
        
        var id=assmval.gpp_userID;
        var date=assmval.gpp_date;
          
          this.props.fetchPuttPerformance(id, date).then((data) => {   
              var resdata=data.data;
              var troptobj=[]; 
              var st=0;
              {resdata.map((teamval) => (   
  
                 troptobj.push({
                    puttlength:teamval.gpp_puttlength,
                    noputt:teamval.gpp_noputt,
                    putttype:teamval.gpp_putttype,
                    right: teamval.gpp_right,
                    left: teamval.gpp_left,
                    short: teamval.gpp_short,
                    long: teamval.gpp_long,
                    avgputt:teamval.gpp_avgputt,
                    strokes: teamval.gpp_strokes,
                    disright:teamval.gpp_right==0 ? 0 : 1, 
                    disleft:teamval.gpp_left==0 ? 0 : 1, 
                    disshort:teamval.gpp_short==0 ? 0 : 1, 
                    dislong:teamval.gpp_long==0 ? 0 : 1,                  
  
                 }),
                 st=parseFloat(st)+parseFloat(teamval.gpp_strokes)
              ))} 
  
              var totavg=parseFloat((st).toFixed(4));
              this.setState({ 
                 seldate:resdata[0].gpp_date, 
                 student:resdata[0].gpp_userID,
                 formValues:troptobj,
                 sepmore:resdata.length,
                 totavgpoints:totavg
              });
  
              this.setState({ 
                  viewdiv:false,  
                  listdiv:false,              
                  adddiv:false,
                  editdiv:true,
              });
  
          });
      }
  
      deleteForm(assmval){
        this.id = assmval.gpp_userID;
        this.date = assmval.gpp_date;
        this.confirmationDialog.current.openDialog();
      }
  
     deleteDataPermanent(popupResponse){
        
           if (popupResponse) {
              this.props.deletePuttPerformance(this.id, this.date);
              this.data = ""
           }
    }

    onPuttBackSection() {
		this.setState({ 
            adddiv:false,
            listdiv:false,
            viewdiv2:true,
       });
	}



render() {

    const { playerinterventionlist, puttperformancelist, loading} = this.props;   
    
    const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
    };

    const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
        
    ];
    const tabledata=puttperformancelist.map((assmntval,idx) => {     
        const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
        const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
            no:idx+1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: ebtn,
            action1:dbtn,
            
            }
    });

      return(
        <div>   
                {this.state.maindiv && 
                    <>
                        <div className="row" style={{marginBottom:"20px"}}>
                            <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                            <div className="col-lg-8"><h2 className="text-center">ON RANGE PUTTING TESTS</h2></div>
                            <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1()}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}>    
                                <Card className="rct-block">
                                    <List className="p-0 fs-14">
                                        <ListItem className="d-flex justify-content-between border-bottom  align-items-center p-15">
                                            <span>
                                                <button class="mr-3 mb-3 btn btn-outline-success" onClick={() =>this.rangeSelection(1)}>PUTTING 5FTBROADIE DRILL</button>                                       
                                            </span>
                                            <span><strong>{playerinterventionlist.onrangetest.putt5drill}</strong></span>
                                        </ListItem>
                                        <ListItem className="d-flex justify-content-between align-items-center border-bottom p-15">
                                            <span>
                                            <button class="mr-3 mb-3 btn btn-outline-success" onClick={() =>this.rangeSelection(2)}>PUTTING 10FTBROADIE DRILL</button>
                                            </span>
                                            <span><strong>{playerinterventionlist.onrangetest.putt10drill}</strong></span>
                                        </ListItem>
                                        <ListItem className="d-flex justify-content-between align-items-center p-15">
                                            <span>                                        
                                            <button class="mr-3 mb-3 btn btn-outline-success" onClick={() =>this.rangeSelection(3)}>PUTTING 15FTBROADIE DRILL</button>
                                            </span>
                                            <span><strong>{playerinterventionlist.onrangetest.putt15drill}</strong></span>
                                        </ListItem>
                                        <ListItem className="d-flex justify-content-between align-items-center p-15">
                                            <span>                                        
                                            <button class="mr-3 mb-3 btn btn-outline-success" onClick={() =>this.rangeSelection(4)}>PUTTING 100FTBROADIE DRILL</button>
                                            </span>
                                            <span><strong>{playerinterventionlist.onrangetest.putt100drill}</strong></span>
                                        </ListItem>
                                    </List>
                                </Card>
                            </div>
                            <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}>    
                                <Card className="rct-block">
                                    <span style={{margin:"0 auto", marginTop:"20%"}}>                                        
                                        <button class="mr-3 mb-3 btn btn-outline-success" onClick={() =>this.rangeSelection(5)}>STROKES GAINED RANDOM PERFORMANCE</button>
                                        <strong>{playerinterventionlist.onrangetest.puttperf}</strong>
                                    </span>
                                </Card>
                            </div>    
                        </div>
                    </>        
                } 

                {this.state.putt5div &&
                    <>
                        <div className="row" style={{marginBottom:"20px"}}>
                            <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                            <div className="col-lg-8"><h2 className="text-center">ON RANGE PUTTING 5FT BROADIE DRILL</h2></div>
                            <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                        </div>
                        <Point5System data={this.state}/>
                        <Putt5System data={this.state}/>
                    </>
                }

                {this.state.putt10div &&
                    <>
                        <div className="row" style={{marginBottom:"20px"}}>
                            <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                            <div className="col-lg-8"><h2 className="text-center">ON RANGE PUTTING 10FT BROADIE DRILL</h2></div>
                            <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                        </div>
                        <Point10System data={this.state}/>
                        <Putt10System data={this.state}/>
                    </>
                }

                {this.state.putt15div &&
                    <>
                        <div className="row" style={{marginBottom:"20px"}}>
                            <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                            <div className="col-lg-8"><h2 className="text-center">ON RANGE PUTTING 15FT BROADIE DRILL</h2></div>
                            <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                        </div>
                        <Point15System data={this.state}/>
                        <Putt15System data={this.state}/>
                    </>
                }

                {this.state.putt100div &&
                    <>
                        <div className="row" style={{marginBottom:"20px"}}>
                            <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                            <div className="col-lg-8"><h2 className="text-center">ON RANGE PUTTING 100FT BROADIE DRILL</h2></div>
                            <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                        </div>
                        <Point100System data={this.state}/>
                    </>
                }

                {this.state.puttperdiv &&
                    <>
                        <div className="row" style={{marginBottom:"20px"}}>
                            <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                            <div className="col-lg-8"><h2 className="text-center">ON RANGE PUTTING PERFORMANCE</h2></div>
                            <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={this.onBackSection}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                        </div>
                        <div className="row">
                                                  
                                <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                                    <RctCollapsibleCard>                              
                                        <form autoComplete="off" id="addform" onSubmit={(e)=>this.puttPerformanceSubmit(e)}>              
                                            <div className="row">                                                    
                                                <div className="col-lg-5">
                                                    <FormGroup >
                                                        <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                                selected={this.state.puttstartdate}
                                                                onChange={this.puttselectstart}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown 
                                                            /> 
                                                    </FormGroup>                                          
                                                </div>
                                                <div className="col-lg-5">
                                                    <FormGroup >
                                                        <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                                selected={this.state.puttenddate}
                                                                onChange={this.puttselectend}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                            /> 
                                                    </FormGroup>                                          
                                                </div>
                                                <div className="form-group">                       
                                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                                </div>              
                                            </div>
                                        </form>  
                                    </RctCollapsibleCard>                                                    
                                </div>
                        </div>
                        {this.state.viewdiv2 &&
                         <>
                            <ViewChart onClick={this.addEntry} onClick1={this.viewList} data={this.state}/>
                            <StrokesChart data={this.state}/>
                            <StrokesLine data={this.state}/>
                            <PuttOneChart data={this.state}/>
                            <PuttTwoChart data={this.state}/>
                            <PuttThreeChart data={this.state}/>
                         </>   
                        }


                        {this.state.adddiv&&
                            <AddItem onClick={this.onPuttBackSection} data={this.state}/>
                        }

                        {this.state.listdiv &&
                            <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard heading="PUTT PERFORMANCE LIST" fullBlock>
                                    <MUIDataTable    
                                            title={<div><Button onClick={ ()=>this.onPuttBackSection()} className="btn btn-outline-warning"> Back</Button></div>}                               
                                            data={tabledata}
                                            columns={columns}
                                            options={options} 
                                    />   
                                </RctCollapsibleCard>
                            </div>
                        }

                        {this.state.editdiv && 
                        <EditItem onClick={this.onEditBack} data={this.state}/>              
                        }

                        <ConfirmationDialog
                        ref={this.confirmationDialog}
                        onConfirm={(res) => this.deleteDataPermanent(res)}
                        data={'putt performance'}
                        />
                    </>
                } 


            
           

        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention, puttperformance }) => {
    const { playerinterventionlist, loading } = playerintervention;
    const { puttperformancelist } = puttperformance;
    return { playerinterventionlist, puttperformancelist, loading };
   
}


export default connect(mapStateToProps, {
    stdBDFivePutts,
    stdBDFivePoints,
    stdBDTenPutts,
    stdBDTenPoints,
    stdBDFifteenPutts,
    stdBDFifteenPoints,
    stdBDHundredPoints,
    fetchPuttPerformanceChart,
    studentPuttPerformance,
    fetchPuttPerformance,
    deletePuttPerformance,
    fetchPlayerIntervention
})(GolfRangeTest);
